import classNames from 'classnames';

import CenteredContent from 'components/CenteredContent';

import useStyles from './styles';

function TestimonialWithTitlesFallback() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <CenteredContent className={styles.layout}>
        <div className={styles.grid}>
          <div className={classNames(styles.area, 'area-head')}>
            <div className={styles.textBlock}>
              <div className={classNames(styles.quotes, styles.quotesFallback)} />
              <div className={classNames(styles.title, styles.titleFallback)}>
                <i className="skeleton" />
              </div>
              <div className={classNames(styles.desc, styles.descFallback)}>
                <i className="skeleton" />
              </div>
            </div>
          </div>
          <div className={classNames(styles.area, styles.areaFallback, `area-0`)}>
            <i className="skeleton" />
          </div>
          <div className={classNames(styles.area, styles.areaFallback, `area-1`)}>
            <i className="skeleton" />
          </div>
          <div className={classNames(styles.area, styles.areaFallback, `area-2`)}>
            <i className="skeleton" />
          </div>
        </div>
      </CenteredContent>
    </div>
  );
}

export default TestimonialWithTitlesFallback;
